<template>
  <div class="cart-index">
    <Loading v-if="!requested" />
    <!-- <NavUser @evtLogout="evtLogout" /> -->
    
    <v-dialog v-model="isPayMethod" width="500" persistent style="z-index:1500;" class="cart-summary-choose-payment">
    <ChoosePayMethod
    :confirm="submitOrder"
    :cancel="cancelPayMethod"
    :store="this.store1"
    :payMethod="this.payMethod" />
    </v-dialog>

    <!-- 顶部导航信息 -->
    <TopNavbar :title="'Order Summary'" :bgColor="'bg-main paddLeft'" />
    <div v-if="requested" class="main">
      <div class="order-store-name flex flex-center">
        <div class="store-logo"><img :src="storeinfo.logo" /></div>
        <div class="store-name">{{ storeinfo.title }}</div>
      </div>
      <!-- 桌子信息 -->
      <TablesInfo :tablesInfo="tablesInfo" />
      <div class="product-list" :class="{'product-list_expand': isExpand}">
        <div class="list-header bg-main flex flex-start justify-between">
          <div class="item-name"></div>
          <div class="item-qty">Qty.</div>
          <div class="item-price">{{ $t("translate.price") }}</div>
        </div>
        <!-- 已选择的商品列表 -->
        <div class="list-items flex flex-start justify-between flex1" v-for="(item, index) in goodsList" :key="index" :class="{'line-top':index}">
          <div class="item-image">
            <img :src="item.detail.thumb" />
          </div>
          <div class="item-name">
            <div class="w600">{{item.name || item.detail.title}}</div>
            <div>
              <span v-for="(optName, optIndex) in item.options" :key="optIndex">
                <!-- <Tags :text="optName" v-if="optIndex != 'optionid'" /> -->
                <Tags v-for="(vname, vkey) in optName" :key="vkey" :text="vname" />
              </span>
            </div>
          </div>
          <div class="item-qty">{{item.qty}}</div>
          <div v-if="parseInt(item.isspecial) == 2" class="item-price">RMxx {{ item.optionname }}</div>
          <div v-if="parseInt(item.isspecial) != 2" class="item-price">RM {{ fmPrice(parseFloat(item.price)*parseInt(item.qty)) }}</div>
        </div>

        <div class="popular-order" :class="{'popular-order_isExpand':isExpand}" v-if="topFiveProduct.length">
              <div class="order-headline">
                  <h4>You may want this?</h4>
              </div>

              <div class="delivery-carousel-btn swipe-left">
                <v-btn fab x-small @click="scrollOrderLeft">
                    <v-icon size="26" class="buttonIcon"> 
                        {{ icons.mdiChevronLeft}}
                    </v-icon>
                </v-btn>
              </div>

              <div class="delivery-order-carousel" ref="scrollOrderTab">
                  <div v-for="(product) in topFiveProduct" :key="product.id" class="carousel-items">
                      <v-card width="175" height="90" flat class="carousel-item px-2 py-2">
                          <div class="carousel-item-desc" style="font-size:12px;font-weight:600;font-family:roboto;height:40px;overflow:hidden;">
                              {{ product.title}}
                          </div>
                          <div style=" display:flex;justify-content:space-between;">
                              <span style="font-size:12px;font-weight:600;font-family:roboto">
                                  RM {{ product.marketprice }}
                              </span>
                              <v-btn @click="clickItem(product)" small tile icon class="bg-main">
                                  <v-icon class="whiteIcon" size="20">
                                      {{ icons.mdiPlus}}
                                  </v-icon>
                              </v-btn>
                          </div>
                      </v-card>
                  </div>
              </div>

                <div class="delivery-carousel-btn swipe-right">
                  <v-btn @click="scrollOrderRight" fab x-small>
                      <v-icon size="26" class="buttonIcon">
                          {{ icons.mdiChevronRight}}
                      </v-icon>
                  </v-btn>
              </div>
          </div>
      </div>
          
    <div v-if="requested" class="footer bgwhite" style="z-index:2">
      <div class="custom-form">
        <!--<div class="cart-summary-warning-wrapper">

            <div style="position:relative">

              <div class="box-warning" :class="{'box-warning_active': isNameError}">
                  <div class="box-triangle"></div>
                  <h6>The name is required!</h6>
              </div>

              <van-cell-group v-if="visiable_realname">
                <div class="flex padd5px user-nav-name pl-2 py-2" >
                  <div style="font-size:14px;width:80px;margin-right:10px;">Name *</div>
                    <input ref="receiver_name"  v-model="receiver_name" placeholder="Your name" style="text-align:left;font-size:13px;flex:1;height:24px" class="inputfocus bgwhite"/>
                </div>
                </van-cell-group>
            </div>

          
            <div style="position:relative">
              <div class="box-warning" :class="{'box-warning_active': isPhoneError}">
                  <div class="box-triangle"></div>
                  <h6>The mobile phone number is required!</h6>
              </div>
              <van-cell-group v-if="visiable_phone">
                  <div class="flex padd5px user-nav-name pl-2 py-2">
                    <div style="font-size:14px;width:80px;margin-right:10px">Mobile No. *</div>
                      <vue-tel-input 
                      ref="receiver_phone" 
                      :onlyCountries="phoneCountries" 
                      :required="true" 
                      class="contact-phone bgwhite" 
                      v-model="receiver_phone" 
                      defaultCountry='MY'
                      autocomplete="off"
                      mode='international'
                      @validate="validateMobileInput" 
                      style="flex:1" />
                    <div class="van-field__right-icon">
                      <van-icon name="success" color="green" v-if="isMobileValid" />
                      <van-icon name="cross" color="red" v-if="!isMobileValid" />
                    </div>

                  </div>
              </van-cell-group>
            </div>

            <van-cell-group v-if="visiable_email">
                <div class="flex padd5px user-nav-name pl-2 py-2">
                  <div style="font-size:14px;width:80px;margin-right:10px">Email *</div>
                  <input ref="email" v-model="email" placeholder="abc@example.com" style="text-align:left;font-size:13px;flex:1;height:24px" class="bgwhite"/>
                </div>
            </van-cell-group>
        </div> -->

        <div style="position:relative">
            <div @click="setExpand" class="button-expand-detail" :class="{'button-expand-detail_active':isExpand}">
              {{ isExpand ? 'Less detail' : 'More detail'}}
              <v-icon class="button-expand-detail-icon" :class="{'button-expand-detail-icon_active':isExpand}" color="white">{{icons.mdiMenuDown}}</v-icon>
            </div>

          <div class="expand-detail" :class="{'expand-detail_active': isExpand}">
            <div class="flex mb-2" style="font-size:14px">
              <div v-if="showRemark || !showCoupon" class="delivery-order_remark" :class="{'delivery-remark_active':showRemark}">
                  <div @click="ShowReMark" style="display:flex;align-items:center">
                      <v-icon size="15" class="mr-1 buttonIcon">
                      {{ icons.mdiPencilOutline }}
                      </v-icon>
                      Order's Remark
                  </div>
                  <div v-if="showRemark" class="show-remark">
                      <van-cell-group>
                      <van-field v-if="!store.isEpointEnabled" v-model="order.remark" rows="3" autosize type="textarea" placeholder="Order's Remark" class="show-remark-textarea"/>
                      <van-field v-if="store.isEpointEnabled" v-model="order.remark" rows="3" autosize type="textarea" placeholder="Order's Remark  (max 19 characters)" maxlength="19" class="show-remark-textarea"/>
                      </van-cell-group>

                      <v-btn @click="ShowReMark" small tile color="primary" style="display:block;margin-left:auto;margin-top:8px">
                          save
                      </v-btn>
                  </div>
                </div>
              <div class="delivery-order-coupon" :class="{'delivery-order-coupon_active': showCoupon}" v-if="!showRemark || showCoupon">
                                <div @click="ShowCoupon" style="display:flex;align-items:center" class="my-2">

                                    <v-icon v-if="!showCoupon" size="18" class="mr-1 buttonIcon">
                                        {{icons.mdiLabelPercentOutline}}
                                    </v-icon>
                                    
                                    <v-icon v-if="showCoupon" size="18" class="ml-3 mr-1 buttonIcon">
                                        {{ icons.mdiArrowLeft }}
                                    </v-icon>
                                    {{ showCoupon ? 'back': 'Coupon' }}
                                    
                                </div>
                  <div v-if="showCoupon" style="width:100%" class="order-coupon-show">
                      <van-cell :title="'Coupons'" is-link :value="coupon_code || '0 coupons available'" @click="popupCoupon = coupon_list.length" class="order-coupon-text"/>
                      <van-popup v-model="popupCoupon" position="bottom" :style="{ height: '50%' }">
                      <div class="flex justify-between">
                          <van-button type="danger" size="mini" @click="cleanCoupon">Clean</van-button>
                          <van-button type="info" size="mini" @click="applyCoupon">Okey</van-button>
                      </div>
                      <van-radio-group v-model="coupon_code">
                          <van-cell-group>
                          <van-cell v-for="itemCoupon in coupon_list" :key="itemCoupon" :title="itemCoupon.title" clickable @click="coupon_code = itemCoupon.name">
                              <van-radio slot="right-icon" :name="itemCoupon.name" />
                          </van-cell>
                          </van-cell-group>
                      </van-radio-group>
                      </van-popup>
                  </div>
              </div>
            </div>

            <div class="delivery-terms-privacy" >
                <div @click="ShowTerms" style="display:flex;justify-content: space-between;">
                    <div>
                        <span>Terms and Privacy Policy</span>
                    </div>
                    <div>
                        <v-icon class="buttonIcon" >
                                {{icons.mdiMenuDown}}
                        </v-icon>
                    </div>
                </div>
                <div v-if="showTerms" style="padding:2px 0">
                    <van-checkbox icon-size="12px" v-model="checkbox_tc_value" shape="square">
                    <span>By placing this order, I agree to the {{FASTORDER}} </span>
                    <span class="terms-privacy-link" @click="funTC(`${FASTORDER_BUSINESS_URL}/terms-conditions/`)">Terms & Condition</span> <span>and </span>
                    <span class="terms-privacy-link" @click="funTC(`${FASTORDER_BUSINESS_URL}/privacy-policy/`)">Privacy Policy</span>
                </van-checkbox>
                </div>
            </div>

            <div class="dinein-payment">
              <div class="flex justify-between cart-payment-header">
                  <div style="font-family:roboto;font-size:12px">Payment Summary</div>
                  <div class="cart-payment-btn-dropdown"  @click="hidePayDetail">
                      View Details
                      <div class="dinein-payment-icon" :class="{'dinein-payment-icon__isActive': !isHide}">
                      <v-icon class="buttonIcon" >
                          {{icons.mdiMenuDown}}
                      </v-icon>
                      </div>
                  </div>
              </div>

              <div v-if="!isHide" class="dinein-payment-detail"> 
                  <div v-for="(item, index) in cart.summmary" :key="index">
                      <div class="flex justify-between" style="font-size:13px">
                          <div>{{ item.label }} <span v-if="item.type=='promo' && isCoupon">({{coupon_code}})</span> </div>
                          <div>RM {{ item.text }}</div>
                      </div>
                  </div>
              </div>
            </div>
          </div>

        </div>


        <div class="dinein-payment">
            <div class="dinein-checkout">
                <v-btn @click="checkFormField">
                  <div v-if="!isLoading" class="flex flex-center" >
                    <div style="position:relative">
                      <v-icon>
                      {{icons.mdiCartVariant}}
                    </v-icon>
                    <div class="total-cart-checkout">{{totalQty}}</div>
                    </div>
                    
                    <span class="ml-2">RM {{ cartTotal }}</span>
                  </div>

                  <div v-if="!isLoading" class="flex flex-center">
                    <span >checkout</span>
                    <v-icon size="28">
                      {{ icons.mdiChevronRight}}
                    </v-icon>
                  </div>

                  <div v-else class="flex flex-center mx-auto">
                    <v-progress-circular
                      :width="1"
                      size="20"
                      color="white"
                      indeterminate
                      class="mr-2"
                    ></v-progress-circular>
                    Waiting...
                  </div>

                  
                </v-btn>
            </div>
        </div>
      </div>
    </div>
    </div>
    
  <div>

    <!-- 属性规格窗口内容区 -->
    <van-popup v-model="show2"  :close-on-click-overlay="false" class="attr-wapper" :style="{ background:'#ffffff',height:'100%'}">
      <GoodsAttr v-if="show2" :attrList="currentGood.goods_attr_list" :goods="currentGood" @evtClosePopup="closePopup" @evtGoBack="goBack"
        @evtChooseAttr0="chooseAttr" @evtIsRequired="setIsRequired" />
    </van-popup>

    <div v-if="show2" class="attr-bottom">
        <div ref="posBottom" class="pos-bottom">
          <div class="goods-inventory" v-if="currentGood.counts>=1">{{ $t("translate.stock_quantity") }}: {{currentGood.counts}} {{currentGood.unitname}}</div>

          <div class="select-quanity">
            <van-stepper v-model="qty" disabled-input="true" input-width="40px" button-size="40px" @minus="getCurrentAttrTotal" @plus="getCurrentAttrTotal" />
            <v-btn tile retain-focus-on-click :disabled="!isRequired" class="confirm-btn bg-main" :class="{'btn-on-bg':isRequired, 'btn-off-bg':!isRequired, 'no-more-item':(parseInt(currentGood.counts)>=1 && parseInt(qty) > parseInt(currentGood.counts))}" @click="addToCart">{{ $t("translate.confirm") }} - RM{{ currentAttrTotal }}</v-btn>
          </div>
        </div>
    </div>


  </div>

  </div>
</template>
<script>
import TopNavbar from '../../components/common/TopNavbar.vue'
// import NavUser from '../../components/common/NavUser.vue'
import TablesInfo from '../../components/common/TablesInfo.vue'
import Loading from '../../components/common/Loading.vue'
import Tags from '../../components/common/Tags.vue'
// import GoodsAttr from "../../components/common/GoodsAttr.vue";
import ChoosePayMethod from '../../components/common/ChoosePayMethod.vue'
import { Toast } from 'vant';
import { isNumber } from 'util'
import {  updateDishnumOfCategory, indexPage,cartPage, addToOrder, checkHistoryExist, validateBusinessAndHoliday,getGoodsDetail } from '@/api/api'
import { cartMixin } from '@/mixins/cartMixin'
import { mainMixin } from '@/mixins/mainMixin'
import { mapGetters, mapActions } from 'vuex'
import { parse,stringify } from 'querystring'
import moment from 'moment'
import { FASTORDER,FASTORDER_MY,FASTORDER_BUSINESS_URL } from '@/constants'
import { 
    mdiDotsVertical,
    mdiPencilOutline,
    mdiLabelPercentOutline ,
    mdiMenuDown ,
    mdiCrosshairsGps ,
    mdiArrowRight,
    mdiArrowLeft,
    mdiTimer,
    mdiChevronRight,
    mdiChevronLeft,
    mdiCartVariant,
    mdiPlus
} from '@mdi/js';

export default {
  components: {
    TopNavbar, 
    TablesInfo, 
    Tags,
    Loading,
    GoodsAttr: () => import(/* webpackChunkName: "goodsattr" */ "../../components/common/GoodsAttr.vue"),
    ChoosePayMethod,
  },
  props: {},
  data() {
    return {
      FASTORDER,
      FASTORDER_MY,
      FASTORDER_BUSINESS_URL,

      isLoading: false,
      requested: false,
      receiver_name: '',
      receiver_phone: '',
      email: '',
      phoneCountries: ['MY', 'SG', 'ID'],
      checkbox_tc_value: true,
      checkbox_mobile_value: 0,
      checkbox_mobile_label: 'Update this mobile number into my profile.',
      import_text1: '* Important: ',
      import_text2: 'You will receive an order confirmation SMS and please verify with merchant with your mobile number while collecting your food.',
      tablesInfo: {},
      goodsList: [],
      storeinfo: {},
      cartTotal: 0.00,
      cart: {
        summmary: []
      },
      indexPage: {},
      store: {},
      validateTime: false,
      isCoupon: false,
      popupCoupon: false,
      coupon_code: '',
      coupon_list: [],
      order_remark: '',
      membership_id: '',
      receiver_addr1: '',
      receiver_addr2: '',
      receiver_addr3: '',
      reqUrl: false,
      show: false,
      isWeixin: false,
      is_required_address_takeaway: false,
      isLogin: false,
      isPayMethod: false,
      requestHisOrder: true, //检查历史订单的 request 状态
      hasHistoryOrder: false, //是否存在历史订单
      loading_confirm: false, //是否在确认提交中
      ssouser: false, //sso.user 信息
      dish_datetime: '',
      showDishDatetime: false,
      /*visiable_realname: false,
      visiable_phone: false,
      visiable_email: false,*/
      dishDatetime: new Date(),
      sso: {},
      isEpointEnabled: false,
      isMobileValid: false,

      icons:{
          mdiDotsVertical ,
          mdiPencilOutline ,
          mdiLabelPercentOutline,
          mdiMenuDown,
          mdiCrosshairsGps ,
          mdiArrowRight,
          mdiArrowLeft,
          mdiTimer,
          mdiChevronRight,
          mdiChevronLeft,
          mdiCartVariant,
          mdiPlus
      },
      clearTime:null,
      isPhoneError:false,
      isNameError:false,
      totalQty : 0,
      isExpand:false,
      showCoupon:false,
      showRemark:false,
      showTerms:false,
      isReservation: false,
      orderid: 0, 
      isHide: true,
      topFiveProduct:[],
      products:[],
      overlay: false,
      // checkbox_mobile_label: 'Update this mobile number into my profile.',
      // import_text1: '* Important: ',
      // import_text2: 'You will receive sms for order status update and verification purpose.',
      carts: [],
      isSubmit: false,
      businessHours: {},
      holiday: {},
      payMethod: {},
      storeInfo: {},
      table: {},
        order: {
          isDineIn: true,
          isTakeaway: false,
          isDelivery: false,
          user: {
          name: '',
          contact: '',
          email: '',
          },
          address: {
          name: '',
          address1: '',
          address2: '',
          address3: '',
          city: '',
          state: '',
          country: '',
          zip: '',
          lat: '',
          lng: ''
          },
          schedule: {
          type: false,
          datetime: new Date()
          },
          remark: ''
        },
      show2:false, //goodattr
      qty: 0,
      isRequired:false,
      timeVal: "",
      currentGood: null,
      currentAttr: null,
      isSelectedAttr: false,
      attrPopupHeight: "100%",
      currentAttrTotal: 0.0,
    }
  },
  async created() {
    // this.checkIsBackPage()
    await this.get_data()
    this.is_weixin = this.isOnWeixin()
  },
  mixins: [cartMixin,mainMixin],
  computed: {
    ...mapGetters([ "user_islogin", "user_detail", "cart_qty","store_info"]),
  },

  methods: {
    ...mapActions({

      settingAttrRadio: "shoppping_cart/setAttrRadio",
      setRadioAddons: "shoppping_cart/settingRadioGoodsAddons",
    }),

    showWarning(error_type){
        if(error_type === 'name'){
          this.isPhoneError = false
            this.isNameError =true
            this.clearTime= setTimeout(()=>{
                this.isNameError = false
            },4000)
        }else if(error_type === 'phone'){
            this.isNameError = false
            this.isPhoneError =true
            this.clearTime= setTimeout(()=>{
                this.isPhoneError = false
            },4000)
        }
        this.clearTime
    },
    async addToCart () {
      let is_inventory =
        parseInt(this.currentGood.counts) >= 1 &&
          parseInt(this.qty) <= parseInt(this.currentGood.counts)
          ? true
          : false;
      if (parseInt(this.currentGood.counts) == -1) {
        is_inventory = true;
      }
      if (is_inventory) {
        if (this.isRequired == false) {
          this.$toast("the require option can not empty");
        } else {
          // 是否选择了规格
          const isChoosed = this.currentAttr ? true : false;
          const attr1 = {
            sky: this.currentGood.sky,
            sku: this.currentGood.sku,
            goodsid: this.currentGood.id,
            price: this.currentGood.marketprice,
            options: isChoosed ? this.currentAttr : 0,
            qty: this.qty,
            optionname: isChoosed ? this.getOptionName(this.currentAttr) : 0,
            optionid: isChoosed ? this.getOptionId(this.currentAttr) : ""
          };
          const objQuery = this.getUrlParams({ do: "UpdateDishNumOfCategory" });
          const updateOption = () => {
            const queryParams = Object.assign(objQuery, {
              optype: "add",
              o2uNum: attr1.qty,
              optionid: attr1.optionid,
              dishid: attr1.goodsid
            });

            // console.log('添加到购物车.queryParams', queryParams);
            updateDishnumOfCategory("/app/index.php", queryParams)
              .then(res => {
                const apiResData = {
                  totalprice: res.message.totalprice,
                  totalcount: res.message.totalcount,
                  cart: res.message.cartList,
                  products: false
                };
                
                if (parseInt(res.message.code) == 200) {
                    this.get_data();
                  this.resetCart(apiResData);
                  
                } else {
                  this.$toast(res.message.msg);
                }
              })
              .catch(error => {
                // console.log('添加到购物车.error', error);
              });
          };
        
          updateOption && updateOption();
          this.goBack();
        }
      } else {
        // console.log('数量超出太多了');
      }
    },
    chooseAttr (attrOptions) {
      // console.log('index.attrOptions=======>', attrOptions);
      // 当前菜的被选中的属性信息
      this.currentAttr = attrOptions.attr || null;
      this.isSelectedAttr = true;
      setTimeout(() => {
        this.getCurrentAttrTotal();
      }, 10);
    },
    closePopup () {
      //关闭选择菜名的属性窗口
      this.show2 = false;
    },
    goBack () {
      history.back()
    },
    setIsRequired (isRequired) {
      this.isRequired = isRequired; 
    },
    getCurrentAttrTotal () {
      //获取和计算属性规格的价格信息
      setTimeout(() => {
        let attr_total = 0.0;
        if (this.currentGood) {
          attr_total = parseFloat(this.currentGood.marketprice);
        }
        this.currentAttr &&
          this.currentAttr.length &&
          this.currentAttr.forEach(priceItem => {
            attr_total = attr_total + parseFloat(priceItem.price);
          });
        this.currentAttrTotal = this.fmPrice(attr_total * this.qty);
      }, 10);
    },
    async clickItem(goods){
      const whereJson = this.getUrlParams({ 'do': 'getProductById', 'id': goods.id })
      getGoodsDetail('/app/index.php', whereJson).then(res => {
      const item = res.data
      let counts = parseInt(item.counts), today_counts = parseInt(item.today_counts)
      // response todo begin
      console.log('counts',counts)

      const getRouteQuery = () => {
      let tempParams = this.$route.query
      if (tempParams.h5api == undefined) {
          tempParams["h5api"] = 'on'
      }
      tempParams["do"] = 'validateBusinessAndHoliday' 
      return tempParams
      }
      const updateOption = () => {
      const queryParams = Object.assign(getRouteQuery(), {storeid: this.storeinfo.id});
      validateBusinessAndHoliday("/app/index.php", queryParams)
              .then(res => {
                  this.indexPage = res.data
                  this.store = this.indexPage.store
                  const table_type = this.store_info.table_type

                  if (table_type == 'is_meal'){
                      if (counts == -1 && this.store.is_rest == 1 && this.store.is_show == 1){
                          this.showPopup(Object.assign(item, {goods_attr_list:goods.goods_attr_list}))

                      } else if ((counts - today_counts) > 0 && this.store.is_rest == 1 && this.store.is_show == 1){
                          this.showPopup(Object.assign(item, {goods_attr_list:goods.goods_attr_list, counts:counts - today_counts}))

                      } else if (this.store.is_rest != 1 || this.store.is_show != 1) {
                          this.$toast("Merchant is not operating, please try again later!") // 门店暂停营业中,暂不接单!
                      } else if (counts == 0 || (counts - today_counts) <= 0){
                          this.$toast("Oops, we regret to inform you that this product is out of stock")
                      }
                  } else {
                      if (this.store.is_24_hours_operation == 0 && this.store.is_rest != 1 || this.store.is_show != 1) {
                          this.$toast("Merchant is not operating, please try again later!") // 门店暂停营业中,暂不接单!
                      } else if (this.store.is_24_hours_operation == 0 && counts == -1 && this.store.is_rest == 1 && this.store.is_show == 1){
                          this.showPopup(Object.assign(item, {goods_attr_list:goods.goods_attr_list}))
                      } else if (this.store.is_24_hours_operation == 0 && (counts - today_counts) > 0 && this.store.is_rest == 1 && this.store.is_show == 1){
                          this.showPopup(Object.assign(item, {goods_attr_list:goods.goods_attr_list, counts:counts - today_counts}))
                      } else if (this.store.is_24_hours_operation == 1 && counts == -1 && this.store.is_show == 1){
                          this.showPopup(Object.assign(item, {goods_attr_list:goods.goods_attr_list}))
                      } else if (this.store.is_24_hours_operation == 1 && (counts - today_counts) > 0 && this.store.is_show == 1){
                          this.showPopup(Object.assign(item, {goods_attr_list:goods.goods_attr_list, counts:counts - today_counts}))
                      } else if (counts == 0 || (counts - today_counts) <= 0){
                          this.$toast("Oops, we regret to inform you that this product is out of stock")
                      } else {
                          if (table_type && this.store_info[table_type] == 0) {
                          this.$toast(this.store_info.table_type_error)
                          } else {
                          let newGoods = Object.assign(item, {goods_attr_list:goods.goods_attr_list, counts:counts - today_counts})
                          this.showPopup(newGoods)
                          }
                      }
                  }
              })
              .catch(error => {
                  // console.log('添加到购物车.error', error);
              });
      };
      updateOption();
      // response todo end 
      }).catch((error) => {
          console.log('====>error', error)
      })
    },
    showPopup (currGoods) {
      console.log('goods',currGoods)
      let urlParams = window.location.hash
      history.pushState( (currGoods.id), `Selected:${currGoods.id}`, `${urlParams}/#`)

      this.qty = 1;
      const filterAttr = () => {
        let tmpRadios = {};
        if (currGoods.goods_attr_list.length) {
          currGoods.goods_attr_list.forEach(attr_item => {
            tmpRadios[attr_item.title] =
              attr_item.items[0].is_multiple == 1 ? [] : "";
          });
        }
        return tmpRadios;
      };
      this.currentGood = null;
      this.currentAttr = null;
      this.currentGood = currGoods;
      this.setRadioAddons(filterAttr()); //设置默认选中的规格
      this.settingAttrRadio({
        attr_list: this.currentGood["goods_attr_list"],
        choosed: false
      });

      this.show2 = true;
      this.isSelectedAttr = false;
      this.attrPopupHeight = "100%";
      if (currGoods.goods_attr_list.length == 0) {
        this.isSelectedAttr = true;
        this.currentAttr = { sku: currGoods.sku, attr: {} };
        // this.attrPopupHeight = '40%';
      }
      setTimeout(() => {
        this.getCurrentAttrTotal();
      }, 10);

    },
    scrollOrderLeft(){
        const content = this.$refs.scrollOrderTab
        this.scrollTo(content, -100, 400);
    },
    scrollOrderRight(){
        const content = this.$refs.scrollOrderTab
        this.scrollTo(content, 100, 400);
    },
    productListSorting(productlist){
      const products = productlist
      const goods_list = this.carts 

        let sort_products =  products.sort((a,b) => {
            return parseInt(b.subcount) - parseInt(a.subcount)
        })

        let filter_result = products.filter( item1 => 
        !goods_list.some( item2 => 
            item1.id === item2.id
        ))
        const size = 5
        const topfiveproduct = filter_result.slice(0, size)
        
        topfiveproduct.forEach(data => {
            data.marketprice = parseFloat(data.marketprice).toFixed(2) ;
            return data    
        })  
        this.topFiveProduct = topfiveproduct
    },
    SetTotalQty(goodslist){
      let x = 0
      for(let i=0; i<goodslist.length; i++){
        x += parseInt(goodslist[i].qty)
      }
      this.totalQty = x
    },
    setExpand(){
      this.isExpand = !this.isExpand
      this.isHide = true
      this.showTerms = false
      this.showCoupon= false
      this.showRemark = false
    },
    ShowCoupon(){
        this.showCoupon = !this.showCoupon
        this.isHide = true
        this.showTerms = false
    },
    ShowReMark(){
        this.showRemark= !this.showRemark
        this.isHide = true
        this.showTerms = false
    },
    ShowTerms(){
        this.showTerms= !this.showTerms
        this.showRemark= false
        this.showCoupon =false
        this.isHide = true
    }, 
    hidePayDetail(){
          this.isHide = !this.isHide
          this.showRemark= false
          this.showCoupon = false
          this.showTerms = false
      }, 
    checkIsBackPage() {
      window.addEventListener('pageshow', function (event) {
        if (event.persisted || window.performance && window.performance.navigation.type == 2) {
          //location.reload()
          this.$toast('当前为后退页面返回来的事件')
        }
      })
    },

    get_data() {
      this.getApiData()
    },
    async getApiData() {
      const todo = cartindex => {
        const tempcart = cartindex && cartindex.cart.map(item => {
          let itemFinalPrice = item.marketprice
          if (item.isspecial) {
            if (parseInt(item.isspecial) == 2) {
              itemFinalPrice = item.price
            }
          }
          const tempItem = {
            detail: {
              thumb: item.thumb,
              title: item.title,
            },
            name: item.title,
            options: [item.optionname],
            qty: item.total,
            price: itemFinalPrice
          }
          return tempItem
        })
        this.goodsList = tempcart
          this.SetTotalQty(this.goodsList)

        this.isEpointEnabled = cartindex.store.pos_status && cartindex.store.pos_name==='epoint'? true:false;
        this.goodsList = tempcart
        this.tablesInfo = {
          title: cartindex.table.title,
          promo: cartindex.store.promo || '',
          tel: cartindex.store.tel,
          table: cartindex.table,
          tablezones: cartindex.tablezones,
        }
        this.storeinfo = {
          id: cartindex.store.id,
          title: cartindex.store.title,
          logo: cartindex.store.logo,
          is_rest: cartindex.store.is_rest,
          is_show: cartindex.store.is_show
        }
        /*console.log('visible realname ==>>',cartindex.store.visiable_realname)
        console.log('visible phone ==>>',cartindex.store.visiable_phone)
        console.log('visible email ==>>',cartindex.store.visiable_email)
        this.visiable_realname = (cartindex.store.visiable_realname && cartindex.store.visiable_realname_dinein) || false
        this.visiable_phone = (cartindex.store.visiable_phone && cartindex.store.visiable_phone_dinein) || false
        this.visiable_email = (cartindex.store.visiable_email && cartindex.store.visiable_email_dinein) || false*/

        this.cart.summmary = cartindex.summmary
        this.cartTotal = cartindex.cartTotal || '0.00'
      }

      // if (this.isDevEnv()) {
      //   const cartindex = mockDemo.cartPage.data
      //   cartindex && todo && todo(cartindex)
      //   setTimeout(() => {
      //     this.requested = true
      //   }, 1000)
      // } else {
            //}
        const actname = 'wapmenu'
        const queryParams = this.getUrlParams({ 'h5api': 'on', 'do': 'wapmenu', 'orderid': 0 })
        await cartPage('/app/index.php', queryParams).then(res => {

          const cartindex = res.data
          if (cartindex.wapmenu_type && cartindex.wapmenu_type == 'new_page') {
            window.location.href = cartindex.forward_url
          } else {
            this.isTakeaway = cartindex.isTakeaway || false
            this.isDelivery = cartindex.isDelivery || false
            this.isReservation = cartindex.isReservation || false
            this.isSchedule = cartindex.isSchedule || false
            this.lalamove = cartindex.lalamove || false
            this.scheduleType = cartindex.scheduleType || false
            this.sso = cartindex.sso || {}
            this.is_required_address_takeaway = cartindex.store.is_required_address_takeaway == 1 ? true : false
            this.businessHours = cartindex.businessHours || {}
            this.holiday = cartindex.holiday || {}
            this.payMethod = cartindex.payMethod || {}
            // if (this.isDelivery) {
            //   const current_delivery_address = cartindex.current_delivery_address || false
            //   this.saveCurrentStoreInfo(cartindex.store)
            //   if (current_delivery_address) {
            //     this.saveCurrentAddress(current_delivery_address) //如何用户已选择了地址，返回的时候，要把已选择地址覆盖vuex中的地址
            //   }
            // }
            // this.is_required_address_takeaway = cartindex.store.is_required_address_takeaway == 1 ? true : false
            if (cartindex.cart && cartindex.cart.length) {
              this.carts =  cartindex.cart
              cartindex && todo && todo(cartindex)
              setTimeout(() => {
                this.requested = true
              }, 100)
                  const queryParamsItem = this.getUrlParams({ do: "waplist" });
                  // console.log('开始请求页面数据-queryParams=>', queryParams);
                  indexPage("/app/index.php", queryParamsItem)
                    .then(res => {
                      const indexpage = res.data;
                      // console.log('indexpage ==>>>', indexpage)
                      this.products = indexpage.products
                      this.productListSorting(this.products)
                    })
                    .catch(error => {
                      console.log(error)
                    });
            } else {
              // console.log('购物车为空，返回首页');
              queryParams["do"] = 'waplist'
              const url = { path: '/', query: queryParams }
              this.$router.push(url)
            }
          }
        }).catch((error) => {
          console.log('====>error', error)
        })
    },
    cleanCoupon() {
      this.coupon_code = ''
      this.cart.summmary.promo.text = 0
    },
    applyCoupon() {
      this.isCoupon = this.coupon_code == 'save10'
      this.cart.summmary.promo.text = 0
      if (this.isCoupon)
        this.cart.summmary.promo.text = -10

      this.popupCoupon = false
    },
    placeorder(isShow) {
      if (isShow) {
        this.loading_confirm = true
        this.show = false
        // this.requested = false
        this.choosePayMethod()
      }
    },
    async checkFormField() {
      this.isLoading = true
      let tempParams = this.$route.query
      if (tempParams.h5api == undefined) {
        tempParams["h5api"] = 'on'
      }
      tempParams["do"] = 'validateBusinessAndHoliday' 
      const updateOption = () => {
      console.log('tempParams index.vue(Dine In)', tempParams)
      validateBusinessAndHoliday("/app/index.php", tempParams)
            .then(res => {
              console.log('Res data index.vue(Dine-in)', res.data)
              this.indexPage = res.data
              this.store = this.indexPage.store
              console.log('This store data from php , index.vue(Dine-in) ', this.store)

              // 表单检查 
              let isShow = true
              /*if (this.visiable_realname && !this.receiver_name) {
                this.showWarning('name')
                // this.$toast('The name is required!')
                this.$refs.receiver_name.focus()
                isShow = false
              }
              if (isShow && this.visiable_phone && !this.receiver_phone) {
                this.showWarning('phone')
                // this.$toast('The mobile phone number is required!')
                this.$refs.receiver_phone.focus()
                isShow = false
              }
              if (isShow && this.visiable_phone && this.receiver_phone && !this.isMobileValid) {
                this.$toast('Invalid Mobile Number format. Please enter a valid mobile phone.')
                this.$refs.receiver_phone.focus()
                isShow = false
              }
              if (isShow && this.visiable_email && !this.email) {
                this.$toast('The email is required!')
                this.$refs.email.focus()
                isShow = false
              }*/
              if (this.isReservation && parseFloat(this.cartTotal) < parseFloat(this.tablesInfo.tablezones.limit_price)){
                this.$toast('The total price is not exceed the minimum spend for the reservation!')
                isShow = false
              }
              if (this.store.is_rest != 1 || this.store.is_show != 1){
                this.$toast('Merchant is not operating, Please try again later!')
                isShow = false
              }
              if (isShow && !this.checkbox_tc_value) {
                this.$toast(`Please agree to ${FASTORDER_MY} terms & conditions and privacy policy before placing the order.`)
                isShow = false
              }
              if (isShow){
              this.placeorder(isShow)
              }
            })
            .catch(error => {
              // console.log('添加到购物车.error', error);
            }).finally(() =>{
              this.isLoading = false
            });
      };
      updateOption();
    },

    choosePayMethod(){
        if (this.payMethod.is_redirect == 0){
            this.submitOrder();
        } else {
            this.isPayMethod = true;
        }
    },

    async submitOrder() {
      this.overlay= true

      const queryParams = this.getUrlParams({ 'h5api': 'on', 'do': 'addtoorder' })
      const postData = {
        type: 'add',
        total: this.cartTotal,
        ordertype: 1,
        address: 'undefined',
        receiver_name: this.receiver_name,
        receiver_phone: this.receiver_phone,
        email: this.email,
        isnew_phone: this.checkbox_mobile_value,
        is_tc: this.checkbox_tc_value,
        sex: 1,
        tables: queryParams.tablesid || 0,
        order_id: 0,
        couponid: 0,
        meal_time: '',
        dispatcharea: '',
        dish_datetime: this.dish_datetime,
        membership_id: this.membership_id,
        receiver_addr1: this.receiver_addr1 || '',
        receiver_addr2: this.receiver_addr2 || '',
        receiver_addr3: this.receiver_addr3 || '',
        counts: 0,
        remark: this.order_remark
      }

      if (this.isReservation){
        postData.mode = 3;
        postData.orderid = this.orderid;
        if (queryParams.rtype == 2){
            postData.receiver_name = queryParams.receiver_name || '';
            postData.receiver_phone = queryParams.receiver_phone || '';
        }
      }

      if (this.payMethod.is_redirect == 1) {
          postData.payment_channel = this.payMethod.choosedChannel;
      }

      const strApiName = '/app/index.php?' + this.parseParams(queryParams)
      addToOrder(strApiName, postData).then(res => {
        if (res.type == 'ajax' || res.type == 'json') {
          const strUrl = (res.redirect != '' && res.message == '') ? res.redirect : res.data.orderDetailUrl
          window.location.href = strUrl
        } else {
          this.$toast(res.message || 'request network error1')
          this.loading_confirm = false
          this.requestHisOrder = true
          this.requested = true
        }
      }).catch((error) => {
        console.log('网络错误', error);
        this.loading_confirm = false
        this.requested = true
        this.$toast({
          message: 'request network error',
          onClose: () => {
            // queryParams.do = 'waplist'
            // const url = { path: '/', query: queryParams }
            // this.$router.push(url)
          }
        })
      }).finally(()=>{
          this.overlay= false
      })
    },
    cancelPayMethod() {
        this.isPayMethod = false;
    },
    parseParams(data) {
      try {
        var tempArr = [];
        for (var i in data) {
          var key = encodeURIComponent(i);
          var value = encodeURIComponent(data[i]);
          tempArr.push(key + '=' + value);
        }
        var urlParamsStr = tempArr.join('&');
        return urlParamsStr;
      } catch (err) {
        return '';
      }
    },
    evtLogout(option) {
      this.isLogin = option.isLogin
      this.receiver_name = ''
      this.receiver_phone = ''
    },
    funTC(strLink) {
      window.open(strLink, '_blank')
    },
    validateMobileInput({ number, isValid, country }) {
      this.isMobileValid = isValid;
    },

  }
}

</script>
<style lang="less" scoped>
@import url('../../assets/css/common.less');

.cart-index {
  text-align: left;
  // margin: 36px 0 40px 0;
  margin: 36px 0 0px 0;
  .main {
    background-color: @fff;
    // color: #323233;
    color: @gray3;
    .order-store-name {
      padding: 12px 5px 0px 5px;
      font-size: 18px;
      .store-logo {
        width: 30px;
        border-radius: 50%;
        margin-right: 10px;
        img {
          // width: 40px;
          // height: 40px;
          // object-fit: fill;
          border-radius: 50%;
          width: 100%;
        }
      }
    }

    //顶部内容
    .tables-room {
      padding: 5px;
      font-size: @size14;
      .row {
        margin: 5px 0;
        .label {
          flex-basis: 120px;
        }
        .colons {
          font-weight: 700;
          padding: 0 3px;
        }
        .text {
          color: @rgba-Color1;
          // color: rgba(0, 0, 0, 0.6);
        }
      }
    }
    //菜单列表
    .product-list {
      margin-bottom:350px;
      .item-name {
        flex: 1;
      }
      .item-qty {
        flex-basis: 30px;
        text-align: center;
      }
      .item-price {
        flex-basis: 60px;
        text-align: right;
      }
      .list-header {
        padding: 5px;
      }
      .list-items {
        margin: 5px 0;
        padding: 5px;
        font-size: @size14;
        .item-image {
          flex-basis: 100px;
          margin: 0 8px 0 0;
          img {
            width: 100%;
            max-width: 100px;
            max-height: 75px;
            border-radius: 5px;
          }
        }
      }
      .line-top {
        border-top: 1px solid rgba(0, 0, 0, 0.06);
        
      }
    }
    .product-list_expand{
      margin-bottom:500px;
    }

    .lalmove-dropdown {
      border: 0px;
      background-color: #ffffff;
      font-size: 12px;
      border-radius: 3px;
      // border: 1px solid #eeeeee;
      border: 1px solid @white9;
      padding: 2px 5px;
      width: 50%;
      .lalmove-dropdown-option {
        height: 20px;
        line-height: 20px;
        font-size: 12px;
      }
    }
    .custom-form {
      // margin: 0px 0 106px 0;
      // border-top: 1px solid #eee;
      padding-bottom: 5px;
      background-color: @fff;
      box-shadow: 0 2px 16px 0 rgb(204, 203, 203);
      
    }
    .user-nav-name {
      // padding: 4px 12px;
      background-color: @white4;
      .schedule-item {
        font-size: 12px;
      }
      .user-nav-name-label {
        padding: 0;
        // margin: 5px 0 0 0;
        margin: 2px 0 2px 0;
        font-size: 14px;
        // flex-basis: 105px;
        flex-basis: 80px;
      }
      .user-nav-name-value {
        text-align: right;
        font-size: 12px;
      }
      .warning-error{
        padding:3px 5px;
        animation: outline 1s infinite alternate;
        @keyframes outline{
          0% {
            outline: 1px solid @fff;
              outline-offset: 0px;
            }
          100% {
            outline: 1px solid @red;
              outline-offset: 0px;
              box-shadow: 0 0 6px 0px @red;
            }
        }
      }
      .warning-success{
        padding:3px 5px;
        // outline: 1px solid rgb(76 175 80);
        // box-shadow: 0 0 3px 0px rgb(76 175 80);
      }
      .select-address {
        cursor:pointer;
        margin-left: 10px;
        text-align: right;
        font-size: 14px;
        // color: rgba(0, 0, 0, 0.5);
        color: @rgba-Color2;
        .delivery-address {
          color: black;
        }
        .delivery-contact {
          // color: #ff3838;
          color: @red1;
        }
      }
      .inputfocus {
        padding: 2px 5px;
        border: 0px;
      }
      .inputfocus:focus {
        box-shadow: 0 0px 5px 0px hsla(191, 84%, 64%, 0.35),
          -10px 10px 10px 10px hsla(0, 0%, 100%, 0.5);
      }
      .contact-phone {
        border: 0px;
        text-align: right;
        font-size: 12px;
        > input.vti__input {
          text-align: right;
        }
      }
    }
    .checkbox-mobile-label {
      padding: 1px 0;
      font-size: 13px;
      .linkcolor {
        // color: #0643e9;
        color: @blue1;
      }
    }
    .import_text1 {
      font-weight: bold;
      display: contents;
      font-size: 12px;
    }
    .import_text2 {
      font-weight: bold;
      display: contents;
      font-size: 12px;
    }
  }
  .footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;

    //概览内容
    .summary {
      // background-color: #f0f0f0;
      background-color: @white8;
      padding: 10px 8px;
      font-size: @size14;
      // color: #000000;
      color: black;
      line-height: normal;
      .colons {
        font-weight: 700;
        padding: 0 3px;
      }
      .currency {
        padding: 0 3px;
      }
      .text {
        flex-basis: 50px;
        text-align: right;
        font-size: @size14;
      }
    }

    .place-order {
      // background-color: #4d4d4d !important;
      // color: #ffffff;
      background-color: @gray !important;
      color: @fff;
      .rm-price {
        padding-left: 10px;
      }
      .btn-order {
        padding: 10px 8px;
        // background-color: #ee0a24 !important;
        background-color: @main !important;
        display: flex;
      }
      .colons {
        border-left: 1px solid rgba(255, 255, 255, 0.8);
        flex-basis: 1px;
        height: 10px;
      }
    }
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #ffffff;
    font-size: 10px;
  }

  .block {
    width: 90%;
    // height: 120px;
    text-align: center;
    background-color: #fff;
    border-radius: 5px;
    padding: 10px;
    font-size: 14px;
    // color: #323233;
    color: @gray3;
    .foce-phone-number {
      font-weight: bold;
      font-size: 16px;
      padding: 20px 0;
    }
    .btn-action {
      font-weight: bold;
      font-size: 14px;
      margin: 20px 0 0 0;
      .btn-confirm {
        // color: #ee0a24;
        color: @red2;
      }
      .btn-cancel {
        color: rgba(0, 0, 0, 0.6);
      }
    }
  }


.dinein-payment{
    padding: 0.5rem 1.2rem 0;
    font-size: 14px;
    .dinein-payment-icon{
        transition: .2s ease-in;
    }
    .dinein-payment-icon__isActive{
        transform: rotate(180deg);
    }
    .dinein-payment-detail{
        padding: 10px 0;
        border-bottom: 1px solid @rgb-Color1;
    }
.dinein-checkout{
    button{
        width: 100%;
        padding:22px 5px 22px 10px;
        border-radius: 5px;
        color: @fff;
        background-color: @red;
        display:flex;
        justify-content:space-between;
        animation: button 2s infinite normal ease-in-out;
    }

    @keyframes button{
        0% {
            transform: translateX(-5px);
            box-shadow: 0 15px 10px -10px rgb(0 0 0 / 15%);
        }
        50% {
            transform: translateX(5px);
            box-shadow: -1px 1px 5px 1px @red;
        }
        100% {
            transform: translateX(-5px);
            box-shadow: 0 15px 10px -10px rgb(0 0 0 / 15%);
        }
    }

    span{
      font-size: 13px;
      font-family: roboto !important;
      font-weight: 700;
    }
    .total-cart-checkout{
      display:grid;
      place-items:center;
      font-size:9px;
      position:absolute;
      background-color: @fff;
      color:@main;
      font-weight:800;
      top:-6px;
      right:-7px;
      border-radius: 50%;
      height:16px;
      width:16px;
    }
}
}

.attr-wapper{
  scrollbar-width: none;
}
.attr-wapper::-webkit-scrollbar {
  display: none;
  width: 0px;
}
.attr-bottom {
  font-family:Arial;
  position: fixed;
  max-width: 800px;
  width: 100%;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3002;
  box-shadow: 0px -2px 3px -1px rgba(202, 201, 201, 0.452);
}

.pos-bottom {
  padding: 12px;
  text-align: center;
  background-color: @fff;
  @media only screen and (max-width: 480px){
    padding: 11px 10px 25px 0;

  }
  @media only screen and (max-width: 380px){
    padding: 11px 10px 25px 5px;
  }
  @media only screen and (max-width: 320px){
    padding: 11px 4px 11px 0;
  }

  .goods-inventory{
    margin-left: 80px;
    text-align: left;
    padding-bottom: 5px;
    font-size: 14px;
    color: @green3;
    @media only screen and (max-width: 600px){
      margin-left: 25px;
    }
    @media only screen and (max-width: 420px){
      display: none;
    }
  }

.select-quanity {
  display: flex;
  align-items: center;
  margin: 0 10px;
  text-align: center;
  font-weight: bold;
  @media only screen and (max-width: 420px){
    margin: 0;
  }

  button{
    background-color: @fff;
      width: 40px !important;
      height: 40px !important;
    @media only screen and (max-width: 480px){
      width: 35px !important;
      height: 35px !important;
    }
  }
  input{
    background-color: rgb(204, 50, 50);
    width: 40px !important;
    height: 40px !important;
    font-size: 17px !important;
    @media only screen and (max-width: 480px){
      width: 35px !important;
      height: 35px !important;
    }
    @media only screen and (max-width: 380px){
      width: 30px !important;
      height: 35px !important;
    }
    @media only screen and (max-width: 320px){
      font-size: 15px !important;
    }
  }
  .van-stepper{
    width: 100%;
    max-width:250px;
    @media only screen and (max-width: 600px){
      max-width:140px;
    }
    @media only screen and (max-width: 360px){
      max-width:120px;
    }
    
  }  

  .btn-on-bg {
  background-color: @main;
  }
  .btn-off-bg {
    background-color: rgb(193 193 193);
  }
  .no-more-item {
    background-color: @gray10 !important;
  }
  .confirm-btn {
    padding: 20px !important;
    box-shadow: -1px 2px 8px 1px rgba(0, 0, 0, 0.6);
    -webkit-box-shadow: -1px 5px 8px 1px rgba(0,0,0,0.6);
    -moz-box-shadow: -1px 5px 8px 1px rgba(0,0,0,0.6);
    flex: 1;
    color: @fff;
    font-size: 16px;
    margin: 0 0 0 16px;
    cursor: pointer;
    transition: all 0.1s cubic-bezier(.08,.76,0,1.02);
    
    @media only screen and (max-width: 460px) {
    padding:10px;
    font-size: 14px;
    margin-left: 10px;
    }
    @media only screen and (max-width: 380px) {
    font-size: 12px;
    }
    @media only screen and (max-width: 380px) {
      margin-left: 2px;
    }
  }
  .confirm-btn:active{
    transform: scale(0.98);
  }   
}
}
}

.show-remark{
  color:@gray9;
  margin-top:5px;
  width:100%;
}
.show-remark-textarea{
  width:100%;
  background-color:@rgb-Color2;
}
.terms-privacy-link{
  color: @blue1;
}
.cart-payment-header{
  padding-bottom:3px;
  border-bottom: 1px solid @white9;
}
.cart-payment-btn-dropdown{
  display:flex;
  align-items:center;
  color:@main;
  font-weight:600;
  cursor:pointer
}

.box-warning{
    z-index: 100;
    display: none;
    color: @fff;
    position: absolute;
    left: 0;
    right:0;
    top:-45px;
    width:100%;
    background-color: @red1;
    box-shadow: 0 2px 5px 0 gray;
    padding: 10px 14px;
    margin-bottom: 20px;
    animation: warning .8s infinite alternate;
    @keyframes warning{
        0% {
            box-shadow: 0  0 2px 2px @red;
        }
        100% {
            box-shadow: 0 0 14px 2px @red;
        }
    }
    .box-triangle{
        background-color: @red1;
        position: absolute;
        width: 16px;
        height: 16px;
        transform: rotate(45deg);
        bottom: -7px;
    }
    h6{
        font-size: 13px;
    }
}
.box-warning_active{
    display:block;
}  

.order-delivery-address{
    position:relative;
    padding: 8px 10px 8px 16px;
    width: 100%;
    background-color: @white4;
    border-bottom: 1px solid @rgb-Color1;
    h5{
    margin-bottom: 5px;
    font-size: 15px;
    }
    span{
    font-family: roboto;
    font-size: 12px;
    font-weight: 600;
    color:@rgb-color6;
    }
    .order-delivery-address-detail{
    display:flex;
    align-items: center;
    width:100%;
    
    }
}

.popular-order{
    background-color: @rgb-Color2;
    position: relative; 
    margin-top: 20px;
}
.order-headline{
    font-family: "Open sans",Arial,sans-serif;
    padding: 16px 16px 0;
    color: @gray;
}
.delivery-order-carousel::-webkit-scrollbar { 
    display: none;  /* Safari and Chrome */
}
.delivery-order-carousel{
    display: flex;
    overflow-x: scroll;
    align-items: center;
    padding: 12px 0px;
    margin-left: 5px;
    margin-right: 18px;
    scrollbar-width: none !important;
    .carousel-items:nth-child(1){
    margin:0 16px 0 32px !important;
    }
  .carousel-items{
    margin:0 16px 0 0 !important;
  }
  .carousel-item{
      z-index: inherit;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 14px;
      font-family: "Open sans",Arial, sans-serif;
      font-weight: 100;
      box-shadow: 0 0 10px 0 rgb(221, 221, 221) !important;
      transition: all 0.2s ease-in;
  }
  .carousel-item:hover{
      box-shadow: -8px 10px 4px -3px rgb(201, 201, 201) !important;
  }   
}
.delivery-carousel-btn{
    position: absolute;
    top: 60%;
    transform: translateY(-50%);
    z-index: 1;
    background-color: rgb(255, 255, 255);
    border-radius: 50%;
    padding: 0px ;
    box-shadow: 0 0 10px 0 rgb(221, 221, 221) !important;
    transition: .1s ease-in;

}
.delivery-carousel-btn:hover{
    box-shadow: 0 0 15px 5px rgb(194, 194, 194) !important;
}
.swipe-left{
    left: 5px;
}
.swipe-right{
    right: 3px;
}
.order-delivery-time{
  padding: 8px 10px 8px 10px;
  width: 100%;
  background-color: @white4;
  h5{
    margin-bottom: 5px;
    font-size: 15px;
  }
  span{
    font-family: roboto;
    font-size: 12px;
    font-weight: 600;
  }

    .pre-order{
        animation: move 2s infinite normal ease-in-out;
        color:@fff;
        background-color:@yellow1;
        border-radius: 2px;
        padding:2px 5px;
        font-family: roboto;
        font-size: 14px;
        font-weight: 900;
    }

    @keyframes move {
        0% {
            transform: translateX(-2px);
        }
        50% {
            transform: translateX(2px);
        }
        100% {
            transform: translateX(-2px);
        }
    }

  .order-delivery-select-time{
    display:flex;
    align-items: center;
    width:100%;
    position:static;
    transition: 0.3s ease-in;
    transform: translateX(0)
  }
  .order-delivery-select-time__isActive{
    transform: translateX(-120%);
    position:absolute;
    top:0;
  }
  .order-delivery-edit-time{
    z-index: 10;
    right:0;
    transform:translateX(120%);
    position:absolute;
    padding: 5px 0px 10px 0;
  }
  .order-delivery-edit-time__isActive{
      position:static;
      transform:none;
      transition:0.3s ease-in;
  }
}

.button-expand-detail{
	background-color:@red !important;
	color:@fff !important;
  font-weight:600;
  font-family:roboto;
  color:@fff;
  font-size:13px;
  display:flex;
  justify-content:center;
  align-items:center;
}
.button-expand-detail_active{
  border: none;
}

.expand-detail{
  transform:translateY(100%);
  position: absolute;
  z-index: -100;
  opacity: 0;
}
.expand-detail_active{
  transition: 0.3s linear;
  position: static;
  transform:translateY(0);
  z-index: 2;
  opacity: 1;
}

.button-expand-detail-icon{
  transition:0.3s ease-in;
  transform: rotate(0deg)
}
.button-expand-detail-icon_active{
  transform: rotate(180deg);
}

.delivery-order_remark{
    height:40px;
    flex:1;
    display:flex;
    justify-content: center;
    align-items: center;
    box-shadow: 1px 1px 0px 0px @rgb-Color4;
    border-top: 1px solid @rgb-Color4;
    color:@main;
    font-weight:600;
}

.delivery-remark_active{
    width:100%;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding:10px 10px 10px 10px;
    min-height: 50px;
    height: 100%;
}

.delivery-order-coupon{
    height:40px;
    flex:1;
    display:flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid @rgb-Color4;
    box-shadow: 1px 1px 0px 0px @rgb-Color4;
    color:@main;
    font-weight:600
}
.delivery-order-coupon_active{
    width:100%;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding:10px 0px 0px 0px;
    min-height: 50px;
    height: 100%;
}
.order-coupon-show{
    width:100%;
    background:@main;
}
.order-coupon-text{
    background-color:@white4;
}
.order-coupon-btn{
    align-items:center;
}

.delivery-terms-privacy{
    cursor: pointer;
    padding:2px 16px;
    border-bottom:1px solid @rgb-Color4;
    span{
        font-size: 12px;
        color: @gray6;
    }
}

.delivery-payment{
    padding: 0.3rem 1.2rem 0;
    font-size: 14px;
    .delivery-payment-icon{
        transition: .2s ease-in;
    }
    .delivery-payment-icon__isActive{
        transform: rotate(180deg);
    }
    .delivery-payment-detail{
        padding: 10px 0;
        border-bottom: 1px solid @rgb-Color1;
    }

.delivery-checkout__active{
    button{
        animation: button 2s infinite normal ease-in-out;
    }
    @keyframes button{
        0% {
            transform: translateX(-5px);
            box-shadow: 0 15px 10px -10px rgb(0 0 0 / 15%);
        }
        50% {
            transform: translateX(5px);
            box-shadow: -1px 1px 5px 1px @main;
        }
        100% {
            transform: translateX(-5px);
            box-shadow: 0 15px 10px -10px rgb(0 0 0 / 15%);
        }
    }

}
.delivery-checkout{
    button{
        width: 100%;
        padding:22px 5px 22px 10px;
        border-radius: 5px;
        display:flex;
        justify-content:space-between;
    }

    span{
        font-size: 13px;
        font-family: roboto !important;
        font-weight: 700;
        }
    .total-cart-checkout{
        display:grid;
        place-items:center;
        font-size:9px;
        position:absolute;
        background-color: @fff;
        color:@gray13;
        font-weight:800;
        top:-6px;
        right:-7px;
        border-radius: 50%;
        height:16px;
        width:16px;
    }
    .total-cart-checkout__active{
        color:@main;
    }
}
}

</style>